import { createActionGroup, props } from '@ngrx/store';

/**
 * Announcements from each session recorder, dispatched by that recorder's own effects. Nothing here
 * is a product event — these say "this recorder now has a session", which the cross-link between
 * them waits on.
 */
export const AnalyticsSessionActions = createActionGroup({
  source: 'Analytics Session',
  events: {
    'Rum session detected': props<{ sessionId: string }>(),
    /** Re-dispatched with a new URL each time FullStory starts a session. */
    'Full story session detected': props<{ url: string }>(),
  },
});
